









































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LeftAlignment from '../PageComponents/LandingPageAlignments/RightAlignment.vue';
import LayoutModule from '~/store/layout';

@Component<Footer>({})
export default class Footer extends Vue {
  @Resolve
  public layout!: LayoutModule;
  @Prop()
  public brkPoints!: object;
  @Prop({ default: false })
  public isFixed!: boolean;

  public footerLinks = {
    privacyPolicyLink: 'https://www.us.sumitomo-pharma.com/privacy-notice/index.html',
    termsOfUseLink: 'https://www.us.sumitomo-pharma.com/terms-of-use/index.html',
    consumerHealthLink:'https://www.us.sumitomo-pharma.com/consumer-health-data-privacy-policy/index.html',
  };

  public get footerInfoLinkLocation() {
    return this.layout.configuration.footerInfoLinkLocation;
  }

  public get isTopOrBottomBar() {
    return ['top', 'bottom'].includes(this.footerInfoLinkLocation);
  }

  public get isLeftOrRightBar() {
    return ['left', 'right'].includes(this.footerInfoLinkLocation);
  }

  public get footerLogoSrc() {
    return this.layout.configuration.images.footer || this.$settings.url(this.$settings.footerLogo);
  }

  // public get trademark() {
  //     return this.layout.configuration.images.footer || this.$settings.url(this.$settings.trademark);
  // }
}
